export const RESET = "reset";
export const UPDATE_IS_RECONNECTING = "updateIsReconnecting";
export const UPDATE_CONNECT_STATE = "updateConnectState";
